/** Discovery source labels shown in Runtime Inspector and workspace bar. */
export const DISCOVERY_SOURCE = {
  RUNTIME_DISCOVERY: "Runtime Discovery",
  REGISTRY_CACHE: "Registry Cache",
  MANUAL_REFRESH: "Manual Refresh",
  BACKGROUND_REFRESH: "Background Refresh",
};
